var path = 'app/scripts/modules/ecs/src/pipeline/stages/cloneServerGroup/cloneServerGroupStepLabel.html';
var html = "<span class=\"task-label\"> Clone Server Group: {{step.context.source.serverGroupName}} ({{step.context.region}}) </span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;